import { mode } from "@chakra-ui/theme-tools";

export const globalStyles = {
  colors: {
    brand: {
      50: "#FFF7E6",
      100: "#FFEDCC",
      200: "#FFDB99",
      300: "#FFC966",
      400: "#FFB833",
      500: "#FF9800", // Primary saffron
      600: "#E68900",
      700: "#CC7A00",
      800: "#B36B00",
      900: "#995C00",
    },
    brandScheme: {
      100: "#FFF7E6",
      200: "#FFC966",
      300: "#FFC966",
      400: "#FFC966",
      500: "#FF9800",
      600: "#E68900",
      700: "#995C00",
      800: "#B36B00",
      900: "#995C00",
    },
    brandTabs: {
      100: "#FFF7E6",
      200: "#FF9800",
      300: "#FF9800",
      400: "#FF9800",
      500: "#FF9800",
      600: "#E68900",
      700: "#995C00",
      800: "#B36B00",
      900: "#995C00",
    },
    secondaryGray: {
      100: "#F5F5F5",
      200: "#EEEEEE",
      300: "#E0E0E0",
      400: "#BDBDBD",
      500: "#9E9E9E",
      600: "#757575",
      700: "#616161",
      800: "#424242",
      900: "#212121",
    },
    red: {
      100: "#FFEBEE",
      500: "#F44336",
      600: "#D32F2F",
    },
    blue: {
      50: "#E3F2FD",
      500: "#2196F3",
    },
    orange: {
      100: "#FFF3E0",
      500: "#FF9800",
    },
    green: {
      100: "#E8F5E9",
      500: "#4CAF50",
    },
    navy: {
      50: "#FFF7E6", // Light saffron tint
      100: "#FFEDCC",
      200: "#FFDB99",
      300: "#FFC966",
      400: "#FFB833",
      500: "#FF9800", // Saffron
      600: "#E68900",
      700: "#7A4D00", // Dark saffron/brown
      800: "#5C3A00",
      900: "#3D2600",
    },
    gray: {
      100: "#FAFAFA",
    },
    saffron: {
      50: "#FFF7E6",
      100: "#FFEDCC",
      200: "#FFDB99",
      300: "#FFC966",
      400: "#FFB833",
      500: "#FF9800",
      600: "#E68900",
      700: "#CC7A00",
      800: "#B36B00",
      900: "#995C00",
    },
    indigo: {
      50: "#F3E5F5",
      500: "#673AB7",
      600: "#5E35B1",
    },
  },
  styles: {
    global: (props) => ({
      body: {
        overflowX: "hidden",
        bg: mode("gray.50", "gray.900")(props),
        fontFamily: "DM Sans",
        letterSpacing: "-0.5px",
      },
      input: {
        color: mode("gray.800", "gray.100")(props),
      },
      html: {
        fontFamily: "DM Sans",
      },
    }),
  },
};